import RegisterResearchStart from '@/common/views/RegisterResearchStart.vue';
import UserProfile from '@/common/views/UserProfile.vue';
import RequestResearch from '@/common/views/RequestResearch.vue';
import { isAuthenticated } from '@/common/utils/routerMixins';
import DashboardView from './views/DashboardView.vue';
import LicenceExtension from './views/LicenceExtension.vue';
import OrganisationDetail from './views/OrganisationDetail.vue';
import OrganisationList from './views/OrganisationsList.vue';
import ResearchCreateView from './views/ResearchCreateView.vue';
import ResearchDashboardView from './views/ResearchDashboardView.vue';
import ResearchEditView from './views/ResearchEditView.vue';
import ResearchListView from './views/ResearchListView.vue';

const PREFIX = '/organisation';

const routes = [
  {
    path: `${PREFIX}/`,
    name: 'organisation-dashboard',
    component: DashboardView,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/organisation`,
    name: 'organisation-organisation-detail',
    component: OrganisationDetail,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/organisation-list/`,
    name: 'organisation-list',
    component: OrganisationList,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    // This should also be a public url (separated);
    path: `${PREFIX}/register-research`,
    name: 'organisation-register-research-start',
    component: RegisterResearchStart,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/request-research/`,
    name: 'organisation-request-research',
    component: RequestResearch,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/user-profile/`,
    name: 'organisation-user-profile',
    component: UserProfile,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/create-research/:researchType/`,
    name: 'organisation-create-research',
    component: ResearchCreateView,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/researches/`,
    name: 'organisation-research-list',
    component: ResearchListView,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/researches/:uuid/edit`,
    name: 'organisation-research-edit',
    component: ResearchEditView,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/researches/:uuid/dashboard`,
    name: 'organisation-research-dashboard',
    component: ResearchDashboardView,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'organisation',
    },
  },
  {
    path: `${PREFIX}/licence/`,
    name: 'organisation-licence-extension',
    component: LicenceExtension,
    beforeEnter: isAuthenticated,
    meta: {
      hideNavigation: true,
      hideFooter: true,
      noPadding: true,
    },
  },
];

export default routes;
